module.exports = __webpack_public_path__ + "img/correct.4c1119e5.png";